import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    name: String,
    props: String,
  };

  connect() {
    this.submitListener = (event) => {
      if (!event.detail.success) return;
      this.track();
    };

    this.element.addEventListener("turbo:submit-end", this.submitListener);
  }

  disconnect() {
    if (this.submitListener) {
      this.element.removeEventListener("turbo:submit-end", this.submitListener);
    }
  }

  track() {
    if (typeof window.plausible !== "function" || !this.nameValue) return;

    let props = {};
    try {
      props = this.propsValue ? JSON.parse(this.propsValue) : {};
    } catch (error) {
      console.warn(`Failed to parse analytics props: ${error.message}`);
    }

    window.plausible(this.nameValue, { props });
  }
}
